  import React, { useState } from 'react';
  import { motion, AnimatePresence } from 'framer-motion';
  import './App.css';
  import '@fortawesome/fontawesome-free/css/all.min.css';
  import Loader from './Components/Loader';
  import Navbar from './Components/Navbar';
  import HeroSection from './Components/HeroSection';
  import AboutSection from './Components/AboutSection';
  import PortfolioSection from './Components/PortfolioSection';
  import AutoSlider from './Components/AutoSlider';
  import ContactSection from './Components/ContactSection';
  import Footer from './Components/Footer';
  import ScrollToTop from './Components/ScrollToTop';

  function App() {
    const [activeTab, setActiveTab] = useState('home');

    return (
      <div className="App">
        <Loader />
        {/* نمرر الـ setActiveTab للـ Navbar */}
        <Navbar setActiveTab={setActiveTab} />

        <main className="content-wrapper">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.4 }}
            >
              {activeTab === 'home' && (
                <>
                  <HeroSection />
                  <AboutSection />
                  <PortfolioSection />
                  <AutoSlider />

                  <ContactSection />

                </>
              )}
              {activeTab === 'about' && <AboutSection />}
              {activeTab === 'portfolio' && <PortfolioSection />}
              {activeTab === 'contact' && <ContactSection />}
            </motion.div>
          </AnimatePresence>
        </main>
  <ScrollToTop />
        <Footer />
      </div>
    );
  }
  export default App;